export default "__VITE_ASSET__Bl0QXA4w__"